import React, { useState, useEffect } from 'react';
import ApiService from '../../components/ApiService';
import CustomToast from '../../components/CustomToast';
import Grid from '../../components/tables/Grid';
import View from '../../views/view';
import Modal from '../../components/Modal'
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import AutocompleteInput from '../../components/autoCompliteInputs/FithoutCreate';

const Cashbox = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { id } = useParams();
    const { companyId } = useParams(); // Получаем ID компании из URL
    const { divisionId } = useParams(); // Получаем ID филиала из URL
    const apiUrl = `/firm/${companyId}/division/${divisionId}/cashbox`;

    const [toastMessage, setToastMessage] = useState(null);
    const [toastType, setToastType] = useState(null);
    const [selectedRow, setSelectedRow] = useState(null);
    const [listener, setListener] = useState(0);
    const [isUpdateModalOpen, setIsUpdateModalOpen] = useState(false);
    const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [header, setHeader] = useState('');
    const [ofdId, setOfdId] = useState('');

    const [cashboxData, setCashboxData] = useState({
        id: '',
        model: '',
        dateOfdEnd: '',
        dateFnEnd: '',
        numberFn: '',
        factoryNumber: '',
        RNM: '',
    });

    const columns = [
        { key: 'id', title: 'ИД' },
        { key: 'model', title: 'Модель' },
        { key: 'dateOfdEnd', title: 'Дата окончания ОФД', date: true },
        { key: 'dateFnEnd', title: 'Дата окончания ФН', date: true },
    ];
    const detailsConfig = [
        { key: 'id', label: 'ИД' },
        { key: 'model', label: 'Модель' },
        { key: 'dateOfdEnd', label: 'Дата окончания ОФД', date: true },
        { key: 'dateFnEnd', label: 'Дата окончания ФН', date: true },
        { key: 'ofdName', label: 'ОФД' },
        { key: 'ofdLink', label: 'Ссылка на ОФД' },
        { key: 'numberFn', label: 'Номер ФН' },
        { key: 'factoryNumber', label: 'Зав.№' },
        { key: 'RNM', label: 'РНМ' },
    ];

    useEffect(() => {
        document.title = 'Кассы';
        setHead()
        ApiService.setToastHandlers(setToastMessage, setToastType);

    }, []);

    useEffect(() => {
        if (id) setSelectedRow(id);
    }, [id]);

    const setHead = async () => {
        const response = await ApiService.fetchDataWithToken(`${apiUrl}/header`)
        setHeader(response.message)
    }

    const setSelectRow = (id) => {
        setSelectedRow(id);
        let currentPath = location.pathname;
        if (!currentPath.endsWith('/') && !currentPath.match(/\/\d+\/?$/)) {
            currentPath += '/';
        }
        // Получаем текущий путь и разделяем его по слешам
        let pathSegments = currentPath.split('/');

        // Убедимся, что у нас есть достаточно сегментов для изменения
        if (pathSegments.length > 1) {
            // Заменяем последний сегмент на новый id
            pathSegments[pathSegments.length - 1] = id;

            // Объединяем сегменты обратно в строку и заменяем текущий путь в истории
            navigate(pathSegments.join('/'), { replace: true });
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setCashboxData(prevData => ({ ...prevData, [name]: value }));
    };

    // Функция, вызывающая перерисовку компонента
    const refreshTable = () => {
        setListener(prevKey => prevKey + 1);
    };


    const openCreate = async () => {
        setCashboxData({
            id: '',
            model: '',
            dateOfdEnd: '',
            dateFnEnd: '',
            numberFn: '',
            factoryNumber: '',
            RNM: '',
        })
        setOfdId('')
        setIsCreateModalOpen(true)
    }

    const openUpdate = async () => {
        const response = await ApiService.fetchDataWithToken(`/cashbox/${selectedRow}`)
        setCashboxData({
            id: response[0].id,
            model: response[0].model,
            dateOfdEnd: response[0].dateOfdEnd,
            dateFnEnd: response[0].dateFnEnd,
            numberFn: response[0].numberFn,
            factoryNumber: response[0].factoryNumber,
            RNM: response[0].RNM,
        })
        setOfdId(response[0].ofdId || '')
        setIsUpdateModalOpen(true)
    }

    const updateCashbox = async () => {
        try {
            const updateCashBox = {
                ...cashboxData, // Копируем все текущие данные
                ofdId: ofdId,
            };
            await ApiService.postDataWithToken(`/cashbox/update`, updateCashBox);
            setToastType('success');
            setToastMessage('Касса успешно изменена');
            refreshTable()
            setIsUpdateModalOpen(false)
        } catch (error) {
        }
    }

    const createCashbox = async () => {
        try {
            const createCashBox = {
                ...cashboxData, // Копируем все текущие данные
                ofdId: ofdId,
            };
            await ApiService.postDataWithToken(`${apiUrl}/add`, createCashBox);
            setToastType('success');
            setToastMessage('Касса успешно сохранена');
            refreshTable()
            setIsCreateModalOpen(false)
        } catch (error) {
        }
    }
    const deleteCashbox = async () => {
        try {
            await ApiService.postDataWithToken(`/cashbox/delete`, { id: selectedRow });
            setToastType('success');
            refreshTable()
            setIsDeleteModalOpen(false)
            setToastMessage('Оргтехника успешно удалена');
            let currentPath = location.pathname;

            // Убедимся, что путь заканчивается на слеш, если нет
            if (!currentPath.endsWith('/')) {
                currentPath += '/';
            }

            // Ищем сегмент с id в пути
            const idSegment = `/${id}/`;
            const indexOfId = currentPath.indexOf(idSegment);

            // Если нашли сегмент с id, убираем его из пути
            if (indexOfId !== -1) {
                const updatedPath = currentPath.slice(0, indexOfId) + currentPath.slice(indexOfId + idSegment.length);
                navigate(updatedPath, { replace: true });
            }

        } catch (error) {
        }
    }

    const handleDateChange = (event) => {
        const { name, value } = event.target;
        setCashboxData(prevState => ({
            ...prevState,
            [name]: new Date(value)
        }));
    };

    const formatDate = (dateIn) => {
        if (!dateIn) return '';
        const date = new Date(dateIn)
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');

        return `${year}-${month}-${day}`;
    };

    return (
        <div>
            <div class="header">
                <p>{header}</p>
            </div>
            <div className="grid-view-container">
                <Grid
                    listener={listener}
                    apiUrl={apiUrl}
                    columns={columns}
                    selectedRow={selectedRow}
                    setSelectedRow={setSelectRow}
                />
                <View listener={listener} selectedId={selectedRow} apiUrl={`/cashbox`} detailsConfig={detailsConfig}>
                    <button style={{ height: '45px', margin: '5px' }}
                        className="task-table-button"
                        onClick={() => { openUpdate() }}
                    >
                        Редактировать
                    </button>
                    <button style={{ height: '45px', margin: '5px' }}
                        className="task-table-button"
                        onClick={() => { openCreate() }}
                        alwaysVisible
                    >
                        Создать
                    </button>
                    <button style={{ height: '45px', margin: '5px' }}
                        className="task-table-button"
                        onClick={() => { setIsDeleteModalOpen(true) }}
                    >
                        Удалить
                    </button>
                </View>
            </div>
            <CustomToast message={toastMessage} type={toastType} setMessage={setToastMessage} setType={setToastType} />
            <Modal active={isUpdateModalOpen} setActive={setIsUpdateModalOpen}>
                <p style={{ fontSize: '18px', fontWeight: 'bold', marginBottom: '1em' }}>Редактор кассы {cashboxData.model}</p>
                <p style={{ fontWeight: 'bold' }}>Модель</p>
                <div style={{ marginBottom: "10px" }}>
                    <input type="text" name="model" value={cashboxData.model} onChange={handleInputChange} placeholder="Текст" />
                </div>
                <p style={{ fontWeight: 'bold' }}>Номер ФН</p>
                <div style={{ marginBottom: "10px" }}>
                    <input type="text" name="numberFn" value={cashboxData.numberFn} onChange={handleInputChange} placeholder="Текст" />
                </div>
                <p style={{ fontWeight: 'bold' }}>Заводской номер</p>
                <div style={{ marginBottom: "10px" }}>
                    <input type="text" name="factoryNumber" value={cashboxData.factoryNumber} onChange={handleInputChange} placeholder="Текст" />
                </div>
                <p style={{ fontWeight: 'bold' }}>РНМ</p>
                <div style={{ marginBottom: "10px" }}>
                    <input type="text" name="RNM" value={cashboxData.RNM} onChange={handleInputChange} placeholder="Текст" />
                </div>
                <p style={{ fontWeight: 'bold' }}>ОФД</p>
                <AutocompleteInput
                    apiUrl={`/ofd`}
                    name='name'
                    placeholder="Выбрать"
                    setId={setOfdId}
                    chekValue={ofdId}
                    validation={true}
                />
                <p style={{ fontWeight: 'bold' }}>Дата окончания ОФД</p>
                <div style={{ marginBottom: '10px' }}>
                    <input
                        type='date'
                        name='dateOfdEnd'
                        value={cashboxData.dateOfdEnd ? formatDate(cashboxData.dateOfdEnd) : ''}
                        onChange={handleDateChange}
                    />
                </div>
                <p style={{ fontWeight: 'bold' }}>Дата окончания ФН</p>
                <div style={{ marginBottom: '10px' }}>
                    <input
                        type='date'
                        name='dateFnEnd'
                        value={cashboxData.dateFnEnd ? formatDate(cashboxData.dateFnEnd) : ''}
                        onChange={handleDateChange}
                    />
                </div>
                <button
                    className="button"
                    onClick={updateCashbox}
                >
                    Отправить
                </button>
            </Modal>
            <Modal active={isCreateModalOpen} setActive={setIsCreateModalOpen}>
                <p style={{ fontSize: '18px', fontWeight: 'bold', marginBottom: '1em' }}>Создание кассы</p>
                <p style={{ fontWeight: 'bold' }}>Модель</p>
                <div style={{ marginBottom: "10px" }}>
                    <input type="text" name="model" value={cashboxData.model} onChange={handleInputChange} placeholder="Текст" />
                </div>
                <p style={{ fontWeight: 'bold' }}>Номер ФН</p>
                <div style={{ marginBottom: "10px" }}>
                    <input type="text" name="numberFn" value={cashboxData.numberFn} onChange={handleInputChange} placeholder="Текст" />
                </div>
                <p style={{ fontWeight: 'bold' }}>Заводской номер</p>
                <div style={{ marginBottom: "10px" }}>
                    <input type="text" name="factoryNumber" value={cashboxData.factoryNumber} onChange={handleInputChange} placeholder="Текст" />
                </div>
                <p style={{ fontWeight: 'bold' }}>РНМ</p>
                <div style={{ marginBottom: "10px" }}>
                    <input type="text" name="RNM" value={cashboxData.RNM} onChange={handleInputChange} placeholder="Текст" />
                </div>
                <p style={{ fontWeight: 'bold' }}>ОФД</p>
                <AutocompleteInput
                    apiUrl={`/ofd`}
                    name='name'
                    placeholder="*ОФД"
                    setId={setOfdId}
                    chekValue={ofdId}
                    validation={true}
                />
                <p style={{ fontWeight: 'bold' }}>Дата окончания ОФД</p>
                <div style={{ marginBottom: '10px' }}>
                    <input
                        type='date'
                        name='dateOfdEnd'
                        value={cashboxData.dateOfdEnd ? formatDate(cashboxData.dateOfdEnd) : ''}
                        onChange={handleDateChange}
                    />
                </div>
                <p style={{ fontWeight: 'bold' }}>Дата окончания ФН</p>
                <div style={{ marginBottom: '10px' }}>
                    <input
                        type='date'
                        name='dateFnEnd'
                        value={cashboxData.dateFnEnd ? formatDate(cashboxData.dateFnEnd) : ''}
                        onChange={handleDateChange}
                    />
                </div>
                <button
                    className="button"
                    onClick={createCashbox}
                >
                    Отправить
                </button>
            </Modal>
            <Modal active={isDeleteModalOpen} setActive={setIsDeleteModalOpen}>
                <p style={{ fontSize: '18px', fontWeight: 'bold', marginBottom: '1em' }}> Вы уверены что хотите удалить кассу {selectedRow}</p>
                <button
                    className="button"
                    onClick={deleteCashbox}
                >
                    Да, я уверен(а)
                </button>
            </Modal>
        </div>
    );
};

export default Cashbox